import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { BEComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';

export class BEComponentExtend {
  public static Init(dto: BEComponent) {
    dto.componentType = EnumComponentType.BE;
  }
}
